import { useSelector } from "react-redux";

import { Session, SessionEnv, Store } from "../session";

/**
 * Helper hook to access the global session state.
 */
export function useSession(): Session {
  return useSelector((store: Store) => store.session);
}

/**
 * Helper hook to access global session.state.env || {} as SessionEnv
 */
export function useDefinedEnv(): SessionEnv {
  const { env } = useSession();
  return env ?? ({} as SessionEnv);
}
